:host {
  display: flex;
  flex: 1 1 0;
  flex-direction: column;
  overflow: hidden;
  will-change: flex;
  container: panel / inline-size;
}

::slotted(*) {
  flex-shrink: 1;
}

:host {
  --panel-handle-height: 20px;
  --panel-divider-width: 1px;

  --panel-label-font-weight: var(--bold);
  --panel-label-padding: 0.75rem 0.75rem 0.7rem 2.5rem;
  --panel-label-background: linear-gradient(rgba(255, 255, 255, 0.02), rgb(15 17 22 / 50%));
  --panel-label-border: 1px solid rgba(221, 221, 221, 0.05);
  --panel-label-box-shadow: 0px -2px 5px -3px rgba(0, 0, 0, 0.4) inset;
  --panel-label-transition: background-color 0.1s ease, color 0.1s ease-in-out;
  --panel-label-color: rgba(255, 255, 255, 0.4);
  --panel-label-font-size: 10px;

  --panel-action-font-size: 15px;

  --panel-label-active-color: rgb(255 255 255 / 80%);
  --panel-label-active-background: rgb(255 255 255 / 3%);

  --panel-label-minimized-background: linear-gradient(rgba(255, 255, 255, 0.02), rgb(15 17 22 / 10%));
  --panel-label-minimized-color: rgba(255, 255, 255, 0.1);

  --panel-divider-color: var(--solid-border-color);
  --panel-divider-color-hover: var(--selected-border-color);
  --panel-divider-color-resize: var(--primary-text-color);
}

.panel {
  display: contents;
  overflow: hidden;
  flex: 1 1 auto;
  box-sizing: border-box;


  .label {
    display: flex;
    flex-direction: row;
    text-transform: uppercase;
    line-height: 1;
    margin: 0;
    font-weight: var(--panel-label-font-weight);
    font-size: var(--panel-label-font-size);
    color: var(--panel-label-color);
    padding: var(--panel-label-padding);
    background: var(--panel-label-background);
    border-bottom: var(--panel-label-border);
    box-shadow: var(--panel-label-box-shadow);
    transition: var(--panel-label-transition);

    &.active {
      color: var(--panel-label-active-color);
      background-color: var(--panel-label-active-background);
    }

    .actions {
      margin-left: auto;
      margin-top: -3px;
      margin-bottom: -3px;

      ui-icon {
        font-size: var(--panel-action-font-size);
      }
    }
  }

  &.resizing + .handle:hover .divider,
  &.resizing + .handle .divider {
    background-color: var(--panel-divider-color-resize);
  }

  &.minimized {
    .label {
      background: var(--panel-label-minimized-background);
      color: var(--panel-label-minimized-color);
    }
  }
}

.handle {
  display: flex;
  position: absolute;
  z-index: 10;
  top: auto;
  left: auto;
  user-select: none;

  &.disabled {
    pointer-events: none;
  }

  .divider {
    background-color: var(--panel-divider-color);
  }

  &:hover .divider {
    background-color: var(--panel-divider-color-hover);
  }
}


.horizontal.panel + .handle {
  flex-direction: row;
  cursor: w-resize;
  margin-left: calc(var(--panel-handle-height) / -2);
  width: var(--panel-handle-height);
  height: 100%;

  .divider {
    margin: 0 auto;
    width: var(--panel-divider-width);
    height: 100%;
  }
}


.vertical.panel + .handle {
  flex-direction: row;
  cursor: ns-resize;
  margin-top: calc(var(--panel-handle-height) / -2);
  width: 100%;
  height: var(--panel-handle-height);

  .divider {
    margin: auto 0;
    width: 100%;
    height: var(--panel-divider-width);
  }
}

.handle,
.panel,
.panel ::slotted(*) {
  opacity: 0;
}
.handle.initialized,
.panel.initialized,
.panel.initialized ::slotted(*) {
  opacity: 1;
}
